import { render } from "./UpdateClientData.vue?vue&type=template&id=be1cd99c"
import script from "./UpdateClientData.vue?vue&type=script&lang=js"
export * from "./UpdateClientData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__